import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { missionActions } from "./mission.actions";
import { MissionsService } from "../../services/volunteer/missions.service";

@Injectable()
export class MissionEffects {

    private readonly action$ = inject(Actions);
    private readonly missionsService = inject(MissionsService);

    loadFromApiMission$ = createEffect(() => {
        return this.action$.pipe(
            ofType(missionActions["[Mission-API]LoadMission"]),
            switchMap((payload) => this.missionsService.getMissions(payload.paylod).pipe(
                map(missionsResponse => missionActions["[Mission-API]LoadSuccess"](missionsResponse)),
                catchError((missionsResponse) => of(missionActions["[Mission-API]LoadFailed"](missionsResponse)))
            ))
        )
    })
}